/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type PermissionConsumptionResponse,
    PermissionConsumptionResponseFromJSON,
    PermissionConsumptionResponseToJSON,
} from '../models/PermissionConsumptionResponse';
import {
    type PermissionCreateRequest,
    PermissionCreateRequestFromJSON,
    PermissionCreateRequestToJSON,
} from '../models/PermissionCreateRequest';
import {
    type PermissionResponse,
    PermissionResponseFromJSON,
    PermissionResponseToJSON,
} from '../models/PermissionResponse';
import {
    type PermissionResponsePagedResult,
    PermissionResponsePagedResultFromJSON,
    PermissionResponsePagedResultToJSON,
} from '../models/PermissionResponsePagedResult';
import {
    type PermissionSearchOrderBy,
    PermissionSearchOrderByFromJSON,
    PermissionSearchOrderByToJSON,
} from '../models/PermissionSearchOrderBy';
import {
    type PermissionSearchRequest,
    PermissionSearchRequestFromJSON,
    PermissionSearchRequestToJSON,
} from '../models/PermissionSearchRequest';
import {
    type PermissionUpdateRequest,
    PermissionUpdateRequestFromJSON,
    PermissionUpdateRequestToJSON,
} from '../models/PermissionUpdateRequest';
import {
    type ResourceFilter,
    ResourceFilterFromJSON,
    ResourceFilterToJSON,
} from '../models/ResourceFilter';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';
import {
    type UserType,
    UserTypeFromJSON,
    UserTypeToJSON,
} from '../models/UserType';

export interface ApiPermissionsCheckusageGetRequest {
    id?: any;
}

export interface ApiPermissionsGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: PermissionSearchOrderBy;
    applicationId?: string;
    isGlobal?: boolean;
    textFilter?: string;
    roleId?: any;
    permissionId?: any;
    userType?: UserType;
    userId?: string;
    resourceFilter?: ResourceFilter;
    requireUserOrganizationInMinSide?: boolean;
}

export interface ApiPermissionsIdDeleteRequest {
    id: number;
}

export interface ApiPermissionsIdPutRequest {
    id: number;
    permissionUpdateRequest: PermissionUpdateRequest;
}

export interface ApiPermissionsPostRequest {
    permissionCreateRequest: PermissionCreateRequest;
}

export interface ApiPermissionsSearchesPostRequest {
    permissionSearchRequest: PermissionSearchRequest;
}

export interface GetPermissionbyIdRequest {
    id: number;
}

/**
 * 
 */
export class PermissionsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiPermissionsCheckusageGet without sending the request
     */
    async apiPermissionsCheckusageGetRequestOpts(requestParameters: ApiPermissionsCheckusageGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/permissions/checkusage`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiPermissionsCheckusageGetRaw(requestParameters: ApiPermissionsCheckusageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionConsumptionResponse>> {
        const requestOptions = await this.apiPermissionsCheckusageGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionConsumptionResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiPermissionsCheckusageGet(requestParameters: ApiPermissionsCheckusageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionConsumptionResponse> {
        const response = await this.apiPermissionsCheckusageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiPermissionsGet without sending the request
     */
    async apiPermissionsGetRequestOpts(requestParameters: ApiPermissionsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        if (requestParameters['applicationId'] != null) {
            queryParameters['ApplicationId'] = requestParameters['applicationId'];
        }

        if (requestParameters['isGlobal'] != null) {
            queryParameters['IsGlobal'] = requestParameters['isGlobal'];
        }

        if (requestParameters['textFilter'] != null) {
            queryParameters['TextFilter'] = requestParameters['textFilter'];
        }

        if (requestParameters['roleId'] != null) {
            queryParameters['RoleId'] = requestParameters['roleId'];
        }

        if (requestParameters['permissionId'] != null) {
            queryParameters['PermissionId'] = requestParameters['permissionId'];
        }

        if (requestParameters['userType'] != null) {
            queryParameters['UserType'] = requestParameters['userType'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['UserId'] = requestParameters['userId'];
        }

        if (requestParameters['resourceFilter'] != null) {
            queryParameters['ResourceFilter'] = requestParameters['resourceFilter'];
        }

        if (requestParameters['requireUserOrganizationInMinSide'] != null) {
            queryParameters['RequireUserOrganizationInMinSide'] = requestParameters['requireUserOrganizationInMinSide'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/permissions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiPermissionsGetRaw(requestParameters: ApiPermissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionResponsePagedResult>> {
        const requestOptions = await this.apiPermissionsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiPermissionsGet(requestParameters: ApiPermissionsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionResponsePagedResult> {
        const response = await this.apiPermissionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiPermissionsIdDelete without sending the request
     */
    async apiPermissionsIdDeleteRequestOpts(requestParameters: ApiPermissionsIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiPermissionsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/permissions/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiPermissionsIdDeleteRaw(requestParameters: ApiPermissionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiPermissionsIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPermissionsIdDelete(requestParameters: ApiPermissionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPermissionsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiPermissionsIdPut without sending the request
     */
    async apiPermissionsIdPutRequestOpts(requestParameters: ApiPermissionsIdPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiPermissionsIdPut().'
            );
        }

        if (requestParameters['permissionUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'permissionUpdateRequest',
                'Required parameter "permissionUpdateRequest" was null or undefined when calling apiPermissionsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/permissions/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PermissionUpdateRequestToJSON(requestParameters['permissionUpdateRequest']),
        };
    }

    /**
     */
    async apiPermissionsIdPutRaw(requestParameters: ApiPermissionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionResponse>> {
        const requestOptions = await this.apiPermissionsIdPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiPermissionsIdPut(requestParameters: ApiPermissionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionResponse> {
        const response = await this.apiPermissionsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiPermissionsPost without sending the request
     */
    async apiPermissionsPostRequestOpts(requestParameters: ApiPermissionsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['permissionCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'permissionCreateRequest',
                'Required parameter "permissionCreateRequest" was null or undefined when calling apiPermissionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/permissions`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PermissionCreateRequestToJSON(requestParameters['permissionCreateRequest']),
        };
    }

    /**
     */
    async apiPermissionsPostRaw(requestParameters: ApiPermissionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionResponse>> {
        const requestOptions = await this.apiPermissionsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiPermissionsPost(requestParameters: ApiPermissionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionResponse | null | undefined > {
        const response = await this.apiPermissionsPostRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Creates request options for apiPermissionsSearchesPost without sending the request
     */
    async apiPermissionsSearchesPostRequestOpts(requestParameters: ApiPermissionsSearchesPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['permissionSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'permissionSearchRequest',
                'Required parameter "permissionSearchRequest" was null or undefined when calling apiPermissionsSearchesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/permissions/searches`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PermissionSearchRequestToJSON(requestParameters['permissionSearchRequest']),
        };
    }

    /**
     */
    async apiPermissionsSearchesPostRaw(requestParameters: ApiPermissionsSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionResponsePagedResult>> {
        const requestOptions = await this.apiPermissionsSearchesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiPermissionsSearchesPost(requestParameters: ApiPermissionsSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionResponsePagedResult> {
        const response = await this.apiPermissionsSearchesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPermissionbyId without sending the request
     */
    async getPermissionbyIdRequestOpts(requestParameters: GetPermissionbyIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPermissionbyId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/permissions/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPermissionbyIdRaw(requestParameters: GetPermissionbyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionResponse>> {
        const requestOptions = await this.getPermissionbyIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPermissionbyId(requestParameters: GetPermissionbyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionResponse> {
        const response = await this.getPermissionbyIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
